import React from "react";
import ZeytinburnuSidebar from "../Sidebar/ZeytinburnuSidebar";
import ZeytinburnuOtherServices from "../ServiceAreas/ZeytinburnuServiceArea";
// import BadgeSection from "../../BadgeSection";
import LeftSidebar from "../../Sidebars/LeftSidebar";
import RightSidebar from "../../Sidebars/RightSidebar";

const ZeytinburnuIntro = () => {
  return (
    <div className="bg-white text-black py-10 px-4 max-w-screen-xl mx-auto">
      <h1 className="mt-0 text-2xl text-center font-bold text-[#003132] mb-4">
        ZEYTİNBURNU HALI-KOLTUK YIKAMA
      </h1>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        {/* İçerik */}
        <div className="order-1 md:order-2 md:col-span-2 space-y-6">
          <p>
            Zeytinburnu, hem tarihi dokusuyla öne çıkan hem de İstanbul'un en yoğun 
            yerleşim alanlarından biri olan bir ilçedir. Bu bölgede halı ve koltuk yıkama hizmetlerine 
            duyulan ihtiyaç, yoğun nüfus ve apartman yaşamı nedeniyle oldukça fazladır. Biz, 
            Zeytinburnu sakinlerine hijyenik, profesyonel ve zamanında hizmet sunarak bu 
            ihtiyacı karşılıyoruz.
          </p>

          <p>
            Halı yıkama işlemlerimizde tam otomatik makineler, ön toz alma üniteleri, leke çıkarma 
            kümeleri ve kurutma odaları kullanılmaktadır. Her halı, türüne ve dokuma yapısına 
            göre ayrılarak uygun yıkama programına tabi tutulur. Koltuk yıkama hizmetimizde ise 
            özel buharlı sistemler, vakumlu temizleme cihazları ve kumaşa zarar vermeyen 
            organik deterjanlar kullanılır.
          </p>

          <p><strong>Zeytinburnu halı-koltuk yıkama hizmetimizin başlıca özellikleri:</strong></p>
          <ul className="list-disc list-inside">
            <li>Tüm mahallelerden aynı gün içinde ürün alım ve teslimat</li>
            <li>Organik, çevre dostu ve anti-alerjen temizlik maddeleri</li>
            <li>Koltuklarda buharlı sistemle derinlemesine temizlik</li>
            <li>Yorgan, battaniye, perde yıkama hizmetleri</li>
            <li>Leke çıkarma garantisi ve tam kurutma sistemi</li>
            <li>Hizmet öncesi ve sonrası bilgilendirme ve fotoğraf ile takip</li>
            <li>48 saat içinde teslimat garantisi</li>
          </ul>

          <p>
            Özellikle Beştelsiz, Veliefendi, Telsiz, Seyitnizam, Nuripaşa, Çirpici ve Merkezefendi 
            mahallelerinde aktif olarak hizmet veriyoruz. Mobil ekiplerimiz ile adresinizden 
            halı, koltuk ve diğer tekstil ürünlerinizi teslim alıyor, hijyenik şekilde yıkanmış ve 
            paketlenmiş olarak geri getiriyoruz.
          </p>

          <p>
            Koltuklarınızda zamanla oluşan lekeler, tozlar ve mikroplar özel sistemlerimizle yok 
            edilir. Kumaş yapısına uygun temizlik maddeleri ve su basıncı düzenleyicili buhar 
            cihazları kullanılır. Halılar ise hav alma, tamburlu yıkama, durulama ve paketleme 
            süreçlerinden geçerek ilk günkü temizliğine kavuşturulur.
          </p>

          <p>
            Zeytinburnu'nda hijyenik ve profesyonel bir temizlik hizmeti arıyorsanız, doğru 
            adrestesiniz. Bizimle hemen iletisim sayfamızdan irtibata geçerek randevu alabilir ya da 
            detaylı bilgi edinebilirsiniz.
          </p>

          {/* Mahalle sidebar ve hizmet bölgeleri */}
          <ZeytinburnuSidebar />
          <ZeytinburnuOtherServices />
        </div>

        {/* Sol Sidebar */}
        <div className="order-2 md:order-1 space-y-6">
          <LeftSidebar />
        </div>

        {/* Sağ Sidebar */}
        <div className="order-3 md:order-3 space-y-6">
          <RightSidebar />
        </div>
      </div>
    </div>
  );
};

export default ZeytinburnuIntro;
